var sb = require('@sb/util')
import api from './api.js'
import ws from './ws.js'
var {cookie} = require('cookie_js')
var tracking = require('./tracking.js')
cookie.defaults.path = '/'
var config = require('@sb/config')

var storage = require('./localstorage.js').default

var bowser = require('bowser')

const VIVNLang = () => import(/*webpackChunkName: "vi-VN" */ '@subiz/lang/widget/vi-VN.js')
const ENUSLang = () => import(/*webpackChunkName: "en-US" */ '@subiz/lang/widget/en-US.js')

const AlertMP3 = () => import(/*webpackChunkName: "alert-mp3" */ '../../assets/media/alert.mp3')
const AlertOGG = () => import(/*webpackChunkName: "alert-ogg" */ '../../assets/media/alert.ogg')

var cssStyleDiv = document.createElement('style')
document.head.appendChild(cssStyleDiv)
cssStyleDiv.type = 'text/css'
cssStyleDiv.id = 'subiz-style'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// account ID must be taken from store.user.account_id
class Store {
	/* public properties */
	isPreview = false // is offline?

	// tell if user is blocked
	// in-sync with is_banned attribute of user
	isBlocked = false

	userSetting = {}

	new_visitor = true

	user = {}
	account = {}
	accountSetting = {}

	// current device (browser info) for tracking purpose
	device = {}

	// map of all agents in the account
	agentM = {}

	// map of all conversations of the user
	convoM = {} // convo key => convo
	convoIdM = {} // convo key => convo id

	// map of all events of all conversations of the user
	convoEventM = {} // ok

	campaignM = {} // campaign id => campaign

	fcmToken = '' // ok

	readyGate = new sb.Gate()
	convoGate = new sb.Gate(true)

	/* private properties */
	pubsub = new sb.Pubsub()
	mask = '' // ok
	anchorM = {} // ok

	seenQueue = [] // convoid will be seen

	i18n = new VueI18n()

	lastview = storage.get('lastview') || {} // last widget screen

	loc = {} // user location (detect from ip)

	async initOff(accid) {
		this.mask = 'mask'
		this.user = {account_id: 'accid1', id: 'userid2'}
		this.setDevice(tracking.getDeviceInfo())
		this.isPreview = false
		this.readyGate.open()
	}

	async init(accid) {
		// dont init twice
		if (sb.get(this.user, 'account_id')) return

		ws.onMessage(this.onWs.bind(this))
		ws.onReconnect(this.onWsReconnect.bind(this))
		this.timeDiff = 0 // server Ms - local Ms

		var mask = cookie.get('__sbmask', '')

		var userId = ''
		// invalid account (may be user has changed their injected code), must recreate user
		if (mask !== '') {
			const parts = mask.split('@')
			if (parts[0] != accid) {
				// wrong mask
				mask = ''
				clearBrowserData()
			} else {
				userId = parts[1]
			}
		}

		if (!mask) {
			this.user = await api.createUser(accid)
			this.mask = this.user.mask
			this.user.account_id = accid // server may not return account id
			cookie.set('__sbmask', this.mask)
			cookie.set('__sbid', this.user.id)
		} else {
			this.new_visitor = false // for checking returning or new visitor

			this.mask = mask
			this.user = await api.getUser(userId)
			this.user.account_id = mask.split('@')[0] // server may not return account id
		}

		this.setDevice(tracking.getDeviceInfo())

		// periodically send seen
		const _seenInterval = setInterval(() => {
			// deduplicate
			this.seenQueue = [...new Set(this.seenQueue)]

			sb.map(this.seenQueue, convokey => {
				var events = this.convoEventM[convokey]
				if (!events) return
				if (sb.size(events) === 0) return

				// find the last message send
				events = sb.filter(events, ev => ev.type === 'message_sent')
				var lastmsgsent = events[sb.size(events) - 1]
				if (!lastmsgsent) return

				let pongs = sb.get(lastmsgsent, 'data.message.pongs', [])
				var seen = sb.find(pongs, pong => pong.type === 'seen' && pong.member_id === this.user.id)

				if (seen) return

				var convoid = sb.convoOfEv(lastmsgsent)
				// fake a pong message from server
				this.onWs({
					id: 'evfff' + sb.randomString(36),
					account_id: this.user.account_id,
					created: Date.now(),
					type: 'message_pong',
					by: {id: this.user.id, client_id: 'widget', type: 'user'},
					data: {
						message: {
							conversation_id: convoid,
							_conversation_key: convokey,
							id: lastmsgsent.id,
							pongs: [{member_id: this.user.id, type: 'seen', created: Date.now, _fake: true}],
						},
					},
				})

				// ignore sending message
				if (lastmsgsent.id === sb.getMsgField(lastmsgsent, 'idempotency')) return

				// send seen
				api.markAsSeen(convoid, lastmsgsent.id)
			})

			this.seenQueue = []
		}, 1000)

		// try to get Google Analytics tracking id and client id by periodically checking it after an interval
		const _gaInterval = setInterval(function() {
			var dev = tracking.getDeviceInfo()
			if (!dev.ga_tracking_ids || !dev.ga_client_id) return
			clearInterval(_gaInterval)
			store.setDevice(dev)
		}, 2000)

		setInterval(() => {
			if (this.isPreview) return
			if (this.isBlocked) return
			api.sendPresence(this.device)
		}, 25 * 1000) // dont bother delete this

		// load alert sound
		try {
			const sound = new window.Audio()
			// sound.addEventListener('canplaythrough', () => rs(sound), false)

			this.alertSound = await AlertMP3()
			if (!document.createElement('audio').canPlayType('audio/mpeg')) {
				this.alertSound = await AlertOGG()
			}
			sound.src = this.alertSound.default
		} catch (e) {
			console.log('SOUND ERR', e)
		}

		await this.resync(this.user.account_id, this.user.id)
		this.readyGate.open()
	}

	// turn previewing mode on, widget is now just for demo
	// we created previewing mode to display widget inside the dashboard
	preview() {
		this.isPreview = true
		this.pubsub.publish('state.isPreview', true)
	}

	setDevice(dev) {
		this.device = dev
		this.pubsub.publish('state.device', dev)
	}

	// set user info, keeping old user id and account id
	async setUser(user) {
		if (!user) return
		await this.readyGate.entry()
		if (this.isPreview) return
		this._setUser(user)
		await api.updateUser(user)
	}

	_setUser(user) {
		var oldAccid = this.user.account_id
		var oldId = this.user.id

		this.user = sb.cloneDeep(user)
		this.user.account_id = oldAccid
		this.user.id = oldId

		this.isBlocked = sb.isUserBanned(this.user)

		this.pubsub.publish('state.user', this.user)
		this.pubsub.publish('state.isBlocked', this.isBlocked)
	}

	setCss(css) {
		if (cssStyleDiv.styleSheet) {
			// This is required for IE8 and below.
			cssStyleDiv.styleSheet.cssText = css
		} else {
			cssStyleDiv.innerHTML = ''
			cssStyleDiv.appendChild(document.createTextNode(css))
		}
	}

	async setSetting(setting) {
		if (!setting) return
		await this.readyGate.entry()
		this._setSetting(setting)
	}

	async _setSetting(setting) {
		setting = sb.cloneDeep(setting)
		fixMissingSetting(setting)

		this.userSetting = setting
		this.accountSetting = setting.account_setting
		delete setting.account_setting

		if (setting.account) {
			this.account = setting.account
			delete setting.account
			this.pubsub.publish('state.account', this.account)
		}

		var agents = sb.get(this.accountSetting, 'agents', [])
		delete this.accountSetting.agents
		if (agents.length > 0) {
			this.agentM = {}
			sb.map(agents, agent => {
				this.agentM[agent.id] = agent
			})
			this.pubsub.publish('state.agentM', this.agentM)
		}

		let campaigns = sb.get(this.userSetting, 'campaigns', [])
		delete this.userSetting.campaigns
		if (campaigns.length > 0) {
			this.campaignM = {}
			sb.map(campaigns, cam => {
				this.campaignM[cam.id] = cam
			})
			this.pubsub.publish('state.campaignM', this.campaignM)
		}

		if (config.mode === 'local') {
			this.setCss('')
			const loadCss = () => import(/*webpackChunkName: "css" */ '../../assets/less/main.less')
			await loadCss()
		} else {
			// download css
			var styleurl = sb.get(this.accountSetting, 'style_url')
			if (styleurl) {
				const style = await api.get(styleurl)
				this.setCss(style)
			}
		}

		await this.setLanguage(this.accountSetting.language, this.accountSetting.custom_language_url)

		this.pubsub.publish('state.userSetting', this.userSetting)
		this.pubsub.publish('state.accountSetting', this.accountSetting)
	}

	async setFcmToken(token) {
		if (!token) return
		this.fcmToken = token
		this.pubsub.publish('state.fcmToken', token)
		await api.updateFcmToken(token)
	}

	async removeFcmToken() {
		if (this.isPreview) return
		if (!this.fcmToken) return
		var fcmtoken = this.fcmToken
		this.fcmToken = ''
		this.pubsub.publish('state.fcmToken', '')
		await api.deleteFcmToken(fcmtoken)
	}

	bind(vue, obj) {
		var out = {}
		let subs = []
		sb.each(obj, key => {
			var path = obj[key]
			// intial value
			out[key] = sb.cloneDeep(sb.get(this, key))

			// watch change
			var sub = this.pubsub.on('state.' + key, value => {
				vue[key] = value // change vue prop
				out[key] = value
			})
			subs.push(sub)
		})

		// unwatch after destroyed
		vue.$once('hook:beforeDestroy', () => subs.map(sub => this.pubsub.un(sub)))
		return out
	}

	// change current language setting
	// accLangCode: en-US || vi-VN
	async setLanguage(accLangCode, custom_language_url, customLangData) {
		console.log('SUBIZ LANG', accLangCode, custom_language_url, customLangData)
		var langCode = accLangCode || ''
		if (!sb.isValidLanguageCode(langCode)) langCode = navigator.language

		// download base lang
		var deflangfunc = langCode === 'vi-VN' || langCode === 'vi' ? VIVNLang : ENUSLang
		var lang = (await deflangfunc()).default

		console.log('SBZ DEF LANG', lang)
		const customLangURL = sb.absURL(custom_language_url)
		// only use custom language if the current language matched predefined lang code in account setting
		customLangData = customLangData || {}

		if (customLangURL && accLangCode === langCode) {
			const customLangFromUrl = await api.get(customLangURL)
			customLangData = Object.assign({}, customLangFromUrl, customLangData)
		}

		lang = Object.assign({}, lang, customLangData)
		this.i18n.setLocaleMessage(langCode, lang)
		this.i18n.locale = langCode
	}

	sendEventToThirdParty(category, action, label) {
		tracking.sendEventToThirdParty(category, action, label)
	}

	// send the content view, the first presence and record domain
	async track() {
		if (this.isPreview) return
		await api.sendPresence(this.device)
		await api.sendContent(this.device, location.href, document.title)
		await api.recordDomain({a: this.user.account_id, u: this.user.id, p: location.href})
	}

	async fetchConvo(convoKey) {
		if (this.isPreview) return
		await this.convoGate.entry()
		let convo = await api.getConversation(this.convoIdM[convoKey])
		convo._key = convoKey
		this.convoM[convoKey] = convo
		await this.fetchOlder(convoKey)
		return convo
	}

	// manually set list of conversation
	// for development only
	_setConvos(convos) {
		this.convoM = {}
		convos.map(convo => {
			convo._key = convo.id
			this.convoM[convo.id] = convo
			this.convoIdM[convo.id] = convo.id
			this.pubsub.publish('state.convoM', this.convoM, convo.id)
		})
	}

	onWsReconnect() {
		if (this.isPreview) return
		this.resync(this.user.account_id, this.user.id)
	}

	lookupConvoKey(convoId) {
		for (let key in this.convoIdM) {
			if (this.convoIdM[key] === convoId) return key
		}
		return ''
	}

	onWs(ev) {
		if (!ev || !ev.type) return
		let convoKey = sb.convoKeyOfEv(ev)
		let convoId = sb.convoOfEv(ev)
		if (!convoKey) convoKey = this.lookupConvoKey(convoId)
		if (!convoKey && convoId) {
			convoKey = convoId // use convo id as convo key
			this.convoIdM[convoKey] = convoId
		}
		sb.convoKeyToEv(convoKey, ev) // inject convo key
		this.wsConvoEvent(ev)
		this.wsUserInfoUpdated(ev)
		this.wsConversationJoined(ev)
	}

	wsConvoEvent(ev) {
		if (!CONVOEVENTS.includes(ev.type)) return

		sb.backwardCompatibleEv(ev, this.user)

		let convoKey = sb.convoKeyOfEv(ev)

		if (!this.convoM[convoKey]) this.convoM[convoKey] = {_key: convoKey}
		if (ev.type === 'message_pong') {
			// update pongged message
			var msgid = sb.get(ev, 'data.message.id')
			if (!sb.get(this.convoEventM, `${convoKey}.${msgid}.data.message`)) return

			var pongs = sb.get(this.convoEventM, `${convoKey}.${msgid}.data.message.pongs`, [])
			pongs = pongs.concat(sb.get(ev, 'data.message.pongs', []))
			sb.set(this.convoEventM, `${convoKey}.${msgid}.data.message.pongs`, pongs)
		}

		if (ev.type === 'message_sent') {
			// update last message of convo
			sb.set(this.convoM, `${convoKey}.last_message`, sb.get(ev, 'data.message') || {})
			sb.set(this.convoM, `${convoKey}.last_message_id`, ev.id)
		}

		if (ev.type !== 'message_pong' && ev.type !== 'conversation_typing') {
			sb.set(this.convoEventM, convoKey + '.' + ev.id, ev)
		}

		this.handleFormSubmit(convoKey, ev)

		this.pubsub.publish('state.convoM', this.convoM)
		this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		this.pubsub.publish('events', ev)
		this.sendEventToThirdParty('SUBIZ Chat', 'Received', 'User')
	}

	handleFormSubmit(convoKey, ev) {
		// find form submit
		if (ev.type !== 'message_sent') return
		// has form submit
		let formSubmits = []
		let attachments = sb.get(ev, 'data.message.attachments') || []
		sb.each(attachments, att => {
			if (!att) return
			if (att.type !== 'form_submit') return
			formSubmits.push(att.form_submit)
		})

		if (sb.size(formSubmits) === 0) return
		sb.each(formSubmits, submit => {
			let formev = sb.get(this.convoEventM, convoKey + '.' + submit.form_message_id)
			if (!formev) return

			// find form attachment
			let forms = sb.filter(sb.get(formev, 'data.message.attachments'), att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				return true
			})

			sb.each(forms, form => {
				form = form.form
				form._submitted = true
				sb.each(form.fields, formfield => {
					sb.each(submit.fields, submitfield => {
						if (formfield.name !== submitfield.name) return
						if (formfield.default_answer) return

						formfield.default_answer = submitfield.value
					})
				})
			})

			if (sb.size(forms) > 0) this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		})
	}

	wsUserInfoUpdated(ev) {
		if (ev.type !== 'user_info_updated') return
		let user = sb.cloneDeep(this.user)
		let attrs = sb.get(ev, 'data.user.attributes') || []
		for (let attr of attrs) {
			sb.setUserAttr(user, attr)
		}
		this._setUser(user)
	}

	async wsConversationJoined(ev) {
		// server doesn't send events before conversation_joined occur
		// so re-get events of this conversation to ensure we dont miss any event
		if (ev.type !== 'conversation_joined') return

		var convoKey = sb.convoKeyOfEv(ev)
		if (!convoKey) return

		let convo = await this.fetchConvo(convoKey)
		if (!convo) return
		this.convoM[convoKey] = convo
		this.convoIdM[convoKey] = convo.id
		this.pubsub.publish('state.convoM', this.convoM, convoKey)
	}

	typing(convoKey) {
		if (!convoKey) return
		if (this.isPreview) return
		if (this.convoIdM[convoKey]) this._typing(this.convoIdM[convoKey])
	}

	_typing = sb.throttle(convoid => api.sendTyping(convoid), 1000)

	updateConvoInfo() {}

	endConvo(convoKey) {
		return api.end(this.convoIdM[convoKey])
	}

	async startConvo(req) {
		if (this.isPreview) return
		await this.readyGate.entry()
		let key = sb.randomString(36)
		this._startConvo(key, req) // dont wait
		let convo = {_key: key, created: Date.now()}
		this.convoM[key] = convo
		return convo
	}

	async _startConvo(convoKey, req) {
		this.convoGate.close()
		let convo = await api.start(req)
		convo._key = convoKey
		this.convoIdM[convoKey] = convo.id
		this.convoM[convoKey] = convo
		this.convoGate.open()
	}

	// fetch older messages of convo
	async fetchOlder(convoKey) {
		let convoid = this.convoIdM[convoKey] || ''
		if (!convoid) return
		let events = await api.getMessages(convoid, -100, this.anchorM[convoKey] || '')
		sb.map(events, ev => {
			sb.convoKeyToEv(convoKey, ev)
			if (ev.type !== 'message_pong' && ev.type !== 'conversation_typing') {
				sb.set(this.convoEventM, convoKey + '.' + ev.id, ev)
			}
		})
		const anchor = sb.get(events, '0.id')
		this.anchorM[convoKey] = anchor
		this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		this.pubsub.publish('state.anchorM', this.anchorM, convoKey)
	}

	async sendConvoEvent(convoKey, message) {
		if (this.isPreview) return
		var idempotency = sb.randomString(36)

		var event = {
			id: idempotency,
			by: {id: this.user.id, type: 'user'},
			data: {message},
			type: 'message_sent',
			created: Date.now(),
		}

		// set chain id for facebook
		message._conversation_key = convoKey

		// set idempotency
		sb.setMsgField(event, 'idempotency', idempotency)
		this.onWs(event) // display sending

		await this.convoGate.entry()
		let convoId = this.convoIdM[convoKey]
		message.conversation_id = convoId

		var restev = await api.sendConvoEvent(convoId, event)
		sb.convoKeyToEv(convoKey, restev) // inject convo key
		this.onWs(restev)
	}

	uploadToS3(files) {
		return api.uploadToS3(files)
	}

	onTime(cb) {
		return this.pubsub.on('time', cb)
	}

	un(subid) {
		return this.pubsub.un(subid)
	}

	onConvoEvent(vue, cb) {
		var sub = this.pubsub.on('events', cb)
		vue.$once('hook:beforeDestroy', () => this.pubsub.un(sub))
		return sub
	}

	seenConvo(key) {
		if (!key) return
		this.seenQueue.push(key)
	}

	now() {
		// millisecond on server
		return Date.now() + this.timeDiff
	}

	onApiError(code) {
		if (
			!(
				code === 'wrong_account_in_credential' ||
				code === 'account_not_found' ||
				code === 'invalid_credential' ||
				code === 'wrong_user_in_credential' ||
				code === 'user_not_found' ||
				code === 'invalid_mask' ||
				code === 'user_is_blocked' ||
				code === 'domain_is_not_whitelisted'
			)
		) {
			return
		}

		if (code !== 'user_is_blocked' && code !== 'domain_is_not_whitelisted') {
			this.isBlocked = true
			this.pubsub.publish('state.isBlocked', this.isBlocked)
			return
		}
	}

	// resubscribe ws and fetch new event from api
	async resync(accid, userid) {
		if (this.isPreview) return
		var events = [
			`conversation_state_updated.account.${accid}.user.${userid}`,
			`conversation_joined.account.${accid}.user.${userid}`,
			`conversation_left.account.${accid}.user.${userid}`,
			`conversation_typing.account.${accid}.user.${userid}`,
			`message_sent.account.${accid}.user.${userid}`,
			`conversation_pending.account.${accid}.user.${userid}`,
			`user_info_updated.account.${accid}.user.${userid}`,
			`message_pong.account.${accid}.user.${userid}`,
		]
		var err = await ws.subscribe(events)
		if (err) return err

		var userSetting = await api.getUserSetting()
		this._setSetting(userSetting)
		this._setUser(this.userSetting.user)
		delete this.userSetting.user

		await this.setLanguage(this.accountSetting.language, this.accountSetting.custom_language_url)

		// refetch convo
		var result = await api.listConversations()
		let convos = sb.get(result, 'conversations', [])
		this.convoM = {}
		convos.map(convo => {
			let key = this.lookupConvoKey(convo.id)
			if (!key) key = convo.id
			convo._key = key
			this.convoM[key] = convo
			this.convoIdM[key] = convo.id
			this.pubsub.publish('state.convoM', this.convoM, key)
		})

		var ops = sb.map(convos, convo => ({
			method: 'GET',
			url: `/4.0/conversations/${convo.id}/messages?limit=-100&x-user-mask=${this.mask}`,
		}))
		result = await api.sendBatchRequest('conversations-events', ops)
		this.convoEventM = {}
		this.anchorM = {}
		sb.map(convos, (convo, i) => {
			const status = sb.get(result, i + '.status', 0)
			if (status !== 200) return

			let events = sb.get(result, i + '.body', [])

			events = sb.orderBy(events, 'created', 'asc')

			let convoKey = convo._key
			sb.map(events, ev => {
				sb.convoKeyToEv(convoKey, ev)
				this.wsConvoEvent(ev)
			})
			const anchor = sb.get(events, '0.id')
			this.anchorM[convoKey] = anchor

			this.pubsub.publish('state.anchorM', this.anchorM, convoKey)
		})
	}

	setLastview(view, opts) {
		this.lastview = {view, opts}
		storage.set('lastview', this.lastview)
	}

	async fetchLocation() {
		if (sb.size(this.loc) === 0) {
			this.loc = await api.getGeoIP()
		}
		return this.loc
	}

	async sendImpression(campid, triggerType) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
		}
		return await api.sendImpression(data)
	}

	async sendConversion(campid, triggerType, submission, impressionToken) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
			submission,
			impression_token: impressionToken,
		}
		return await api.sendConversion(data)
	}

	async setGoalReached(campid) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			status: 'goal_reached',
		}
		return await api.setGoalReached(data)
	}
}

function getOffsetMin(tz = '+07:00') {
	var [hour, min] = tz.split(':')
	hour = parseInt(hour)
	min = parseInt(min)

	if (hour < -12 || hour > 12) {
		hour = 0
	}

	if (min < 0 || min >= 60) {
		min = 0
	}

	return hour * 60 + min
}

function clearBrowserData() {
	const cookies = cookie.all() || {}
	for (var k in cookies) {
		if (cookies.hasOwnProperty(k)) {
			if ((k || '').startsWith('__sb')) cookie.remove(k)
		}
	}

	storage.clear()
}

// set default value if not exists
function fixMissingSetting(setting) {
	// account logo
	if (sb.get(setting, 'account.logo_url') === '') {
		sb.set(setting, 'account.logo_url', 'https://filev4.subiz.com/fiqefagzmrkirsjllpee-logo_01.png')
	}
}

const CONVOEVENTS = [
	`conversation_state_updated`,
	`conversation_joined`,
	`conversation_untagged`,
	`conversation_tagged`,
	`conversation_typing`,
	`conversation_state_updated`,
	`conversation_joined`,
	`conversation_invited`,
	`message_sent`,
	`message_updated`,
	`message_pong`,
	`conversation_member_typing`,
	`conversation_typing`,
]

var store = new Store()
api.setStore(store)
api.onError = store.onApiError.bind(store)

// expose store for debugging purpose
window.sbz_store = store

export default store
